import * as React from 'react'

import { cn } from '~/styled'

import { ColorScheme } from '../../experiments/color-scheme/ColorScheme'
import { PaginationProvider } from './pagination-context/PaginationContext'
import { VisibleElementsAmount } from './pagination.constants'
import { PaginationItems } from './PaginationItems'
import { PaginationPopover } from './PaginationPopover'
import type { PaginationProps, PaginationProviderProps } from './types'

const PaginationComponent = ({
  colorScheme,
  onSelectedPageChange,
  selectedPage,
  visibleElementsCount = VisibleElementsAmount.LESS,
  pagesCount,
  indicatedPages = [],
  disabledPages = [],
  onItemHover = () => null,
  labels = {},
  children,
  className,
  ...rest
}: PaginationProps) => {
  if (!pagesCount) return null

  const paginationProviderProps: PaginationProviderProps = {
    onSelectedPageChange,
    selectedPage,
    visibleElementsCount,
    pagesCount,
    indicatedPages,
    disabledPages,
    onItemHover,
    labels
  }

  return (
    <PaginationProvider {...paginationProviderProps}>
      <ColorScheme base="grey1" accent="primary1" {...colorScheme} asChild>
        <div {...rest} className={cn('flex', 'gap-1', className)}>
          {children || <PaginationItems />}
        </div>
      </ColorScheme>
    </PaginationProvider>
  )
}

export const Pagination = Object.assign(PaginationComponent, {
  Popover: PaginationPopover
})

PaginationComponent.displayName = 'Pagination'
